import script from "./Note.vue?vue&type=script&setup=true&lang=js"
export * from "./Note.vue?vue&type=script&setup=true&lang=js"

import "./Note.vue?vue&type=style&index=0&id=fe2557b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe2557b0"]])

export default __exports__